import React, { useRef,Suspense,useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setFilters, resetFilters} from 'reducers/filtersSHEETSlice';
import { resetPagination } from 'reducers/paginationSHEETSlice';
import { useTranslation } from "react-i18next"
import { useNavigate } from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT, LIMIT_PAGE } from "constants/variables";
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button'; 
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';  
import MenuItem  from "@mui/material/MenuItem"; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import TextField from '@mui/material/TextField'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { setReloadRefreshData } from 'reducers/loadingSlice'; 
import { LoadingNews } from "components/utils/LoadingNews";   
import  TableSortingSHEET from "pages/sheet/filterSHEET/SortingTablesSHEET";
import SHEETPDF from "pages/sheet/generatePDF/SHHETPDF";
import exportSHEETToExcel from "pages/sheet/filterSHEET/SHEETExportToExcel";
import PropTypes from 'prop-types';

const initialFiltersSHEET= {
  idFrom:"",
  idTo:"",
  defaultStoreIdFrom:"",
  defaultStoreIdTo:"",
  useraccountIdFrom:"",
  useraccountIdTo:"",
  numberSheetFrom:"",
  numberSheetTo:"",
  dateSheetFrom:null,
  dateSheetTo:null,
  marcaFrom:"",
  marcaTo:"",
  modeloFrom:"",
  modeloTo:"",
  licensePlateSheetFrom:"",
  licensePlateSheetTo:"",
  frameSheetFrom:"",
  frameSheetTo:"",
  sheetStateFromES:"",
  sheetStateToES:"",
  sheetStateFromEN:"",
  sheetStateToEN:"",
  isFinished:false,
  isPending:true
};
 
const initialDefaultStoresToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": "",
  "name": ""
}];
 
const initialStateSHEET = [{
   "id" : "",
  "ownsheet_id" : "", 
  "defaultStore_id":0,
  "tradename":"",
  "useraccount_id":0,
  "username":"",
  "num_sheet":"",
  "date_sheet":"",
  "vehicle_marca":"",
  "vehicle_model":"",
  "vehicle_sheet":"",
  "frame_sheet":"",
  "sheetStatus_id":  1,
  "sheetStatus_namees": "",
  "sheetStatus_nameen": "",
  "isFinished": false,
  "isPending": true,
}];  

const initialSheetSateToSelect = [{
  "id": "",
  "namees": "",
  "nameen": ""
}];

const initialMarcaToSelect = [{
  "id": "",
  "marca": ""
}];

const initialModelToSelect = [{
  "id": "",
  "model": ""
}];
 
const SHEETFilter = ({ showModalSHEEETSettings,typeOfList}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore);   
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const DELETE_CODE_FORMDI = useSelector((state) => state.formatDIUser.delete_code_formdi); 
  const [dataSHEET, setDataSHEET] = useState(initialStateSHEET);
  const [formSHEET, setFormSHEET] = useState(initialStateSHEET[0]);
  const filtersSHEETDetails = useSelector((state) => state.filtersSHEET);
  const [filtersSHEET, setFiltersSHEET]= useState(filtersSHEETDetails);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegSHEET,setNumTotRegSHEET]= useState(0);
  const [errorsFiltersSHEET, setErrorsFiltersSHEET] = useState({});
  const [inputTextSHEET, setInputTextSHEET] = useState(""); 
  const [openDeleteRowSHEET,setOpenDeleteRowSHEET]= useState(false); 
  const [openEditRowSHEET,setOpenEditRowSHEET]= useState(false);
  const [openEditFilterSHEET,setOpenEditFilterSHEET]= useState(false);
  const [rowEditSHEET,setRowEditSHEET]= useState(initialStateSHEET[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const reloadRefreshData = useSelector((state) => state.loading.isLoading); 
  const [isLoadingErrorSHEET, setIsLoadingErrorSHEET] = useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE);
  const [viewPDF,setViewPDF]=useState(false);  
  const dispatch = useDispatch();
  const [activeOffsetSHEET, setActiveOffsetSHEET]= useState(false);
  const [currencyOffsetSHEET, setCurrencyOffsetSHEET] = useState(0);
  const [rangeOffsetSHEET, setRangeOffsetSHEET] = useState([{}]);
  const [storesToSelect,setStoresToSelect]= useState(initialDefaultStoresToSelect);
  const [sheetStateToSelect,setSheetStateToSelect]= useState(initialSheetSateToSelect);  
  const [refeshData,setRefeshData]=useState(false);  
  const [marcaToSelect,setMarcaToSelect]= useState(initialMarcaToSelect); 
  const [filteredMarcaFrom, setFilteredMarcaFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexMarcaFrom, setHighlightedIndexMarcaFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredMarcaTo, setFilteredMarcaTo] = useState([]); // Opciones filtradas
  const [highlightedIndexMarcaTo, setHighlightedIndexMarcaTo] = useState(-1); // Índice de la opción resaltada
  const [modelToSelect,setModelToSelect]= useState(initialModelToSelect); 
  const [filteredModelFrom, setFilteredModelFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexModelFrom, setHighlightedIndexModelFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredModelTo, setFilteredModelTo] = useState([]); // Opciones filtradas
  const [highlightedIndexModelTo, setHighlightedIndexModelTo] = useState(-1); // Índice de la opción resaltada
  
  const navigate = useNavigate(); 

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalSHEEETSettings) {
        setDataSHEET(initialStateSHEET);
        setFormSHEET(initialStateSHEET[0]);
        setNumTotRegFilter(0);
        setNumTotRegSHEET(0);
        setErrorsFiltersSHEET({});
        setInputTextSHEET("");
        setOpenDeleteRowSHEET(false); 
        setOpenEditRowSHEET(false);
        setOpenEditFilterSHEET(false);
        setRowEditSHEET(initialStateSHEET[0]); 
        setIsLoadingErrorSHEET(false);
        setIdCodeDelete(DELETE_CODE);
        setViewPDF(false);
        setRefeshData(false); 
        setActiveOffsetSHEET(false);
        setCurrencyOffsetSHEET(0);
        setRangeOffsetSHEET([{}]);
        setStoresToSelect(initialDefaultStoresToSelect);
        setSheetStateToSelect(initialSheetSateToSelect); 
        setMarcaToSelect(initialMarcaToSelect);
        setFilteredMarcaFrom([]);
        setHighlightedIndexMarcaFrom(-1); 
        setFilteredMarcaTo([]);  
        setHighlightedIndexMarcaTo(-1);   
        setModelToSelect(initialModelToSelect);
        setFilteredModelFrom([]);
        setHighlightedIndexModelFrom(-1); 
        setFilteredModelTo([]);  
        setHighlightedIndexModelTo(-1);  
        dispatch(setLoading(false));
        dispatch(setReloadRefreshData(false));
        dispatch(resetPagination());
        dispatch(resetFilters());
        setFiltersSHEET(initialFiltersSHEET);  
        navigate("/home");
        return () => {};
      }
    },
    [
      setDataSHEET,
      setFormSHEET,
      setFiltersSHEET,
      setNumTotRegFilter,
      setNumTotRegSHEET,
      setErrorsFiltersSHEET,
      setInputTextSHEET,
      setOpenDeleteRowSHEET, 
      setOpenEditRowSHEET,
      setOpenEditFilterSHEET,
      setRowEditSHEET, 
      setIsLoadingErrorSHEET,
      setIdCodeDelete,
      setViewPDF,
      setRefeshData,
      setActiveOffsetSHEET,
      setCurrencyOffsetSHEET,
      setRangeOffsetSHEET,
      setMarcaToSelect,
      setFilteredMarcaFrom,
      setHighlightedIndexMarcaFrom, 
      setFilteredMarcaTo,
      setHighlightedIndexMarcaTo, 
      setModelToSelect,
      setFilteredModelFrom,
      setHighlightedIndexModelFrom,
      setFilteredModelTo,
      setHighlightedIndexModelTo,  
      setStoresToSelect,
      setSheetStateToSelect,
      showModalSHEEETSettings,
      navigate,
      dispatch,
      DELETE_CODE]
  );

  const closeModalSHEET = () => {    
    setDataSHEET(initialStateSHEET);
    setFormSHEET(initialStateSHEET[0]);
    setNumTotRegFilter(0);
    setNumTotRegSHEET(0);
    setErrorsFiltersSHEET({});
    setInputTextSHEET("");
    setOpenDeleteRowSHEET(false); 
    setOpenEditRowSHEET(false);
    setOpenEditFilterSHEET(false);
    setRowEditSHEET(initialStateSHEET[0]); 
    setIsLoadingErrorSHEET(false);
    setIdCodeDelete(DELETE_CODE);
    setViewPDF(false); 
    setRefeshData(false); 
    setActiveOffsetSHEET(false);
    setCurrencyOffsetSHEET(0);
    setRangeOffsetSHEET([{}]);
    setStoresToSelect(initialDefaultStoresToSelect);
    setSheetStateToSelect(initialSheetSateToSelect);; 
    setMarcaToSelect(initialMarcaToSelect);
    setFilteredMarcaFrom([]);
    setHighlightedIndexMarcaFrom(-1); 
    setFilteredMarcaTo([]);  
    setHighlightedIndexMarcaTo(-1);   
    setModelToSelect(initialModelToSelect);
    setFilteredModelFrom([]);
    setHighlightedIndexModelFrom(-1); 
    setFilteredModelTo([]);  
    setHighlightedIndexModelTo(-1);     
    dispatch(setLoading(false));
    dispatch(setReloadRefreshData(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersSHEET(initialFiltersSHEET); 
    navigate("/home");
    return () => {};
  };

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
  };

  // Dentro del componente
  const debouncedHandleSearchMarcaFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredMarcaFrom([]);
      setHighlightedIndexMarcaFrom(-1);
      return;
    }
    const filtered = marcaToSelect
      .filter(vehicletype => vehicletype && vehicletype.marca)
      .filter(vehicletype => {
        const marcaFROM = vehicletype.marca.toUpperCase();
        return marcaFROM.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredMarcaFrom(filtered);
      setHighlightedIndexMarcaFrom(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectMarcaFrom = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFiltersSHEET(filtersSHEET => ({
      ...filtersSHEET,
      marcaFrom: vehicletype.marca || "",
      marcaTo: vehicletype.marca || filtersSHEET.marcaTo,
    })); 
    setFilteredMarcaFrom([]);
    setHighlightedIndexMarcaFrom(-1);
  }; 
 
  const handleKeyDownMarcaFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredMarcaFrom.length === 0 && filtersSHEET.marcaFrom.trim() === "") {
        setFilteredMarcaFrom(marcaToSelect);
        setHighlightedIndexMarcaFrom(0);
      } else {
        setHighlightedIndexMarcaFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredMarcaFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexMarcaFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexMarcaFrom >= 0) {
      if (highlightedIndexMarcaFrom >= 0 && highlightedIndexMarcaFrom < filteredMarcaFrom.length) {
        handleSelectMarcaFrom(filteredMarcaFrom[highlightedIndexMarcaFrom]);
      }
    } else if (event.key === "Escape") {
      const isValid = marcaToSelect.some((vehicletype) => {
        if (!vehicletype || !vehicletype.marca) return false; 
        const normalizedMarca = vehicletype.marca.toUpperCase();
        const normalizedInputMarca = filtersSHEET.marcaFrom.toUpperCase();
        return normalizedMarca === normalizedInputMarca;
      }); 
      if (!isValid) {
        setFiltersSHEET(filtersSHEET => ({
          ...filtersSHEET,
          marcaFrom: "" 
        })); 
      }
      setFilteredMarcaFrom([]);
      setHighlightedIndexMarcaFrom(-1);
    }
  }; 
 
  // Dentro del componente
  const debouncedHandleSearchMarcaTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredMarcaTo([]);
      setHighlightedIndexMarcaTo(-1);
      return;
    }
    const filtered = marcaToSelect
      .filter(vehicletype=>(vehicletype.marca>=filtersSHEET.marcaFrom))
      .filter(vehicletype => vehicletype && vehicletype.marca)
      .filter(vehicletype => {
        const marca = vehicletype.marca.toUpperCase();
        return marca.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredMarcaTo(filtered);
    setHighlightedIndexMarcaTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectMarcaTo = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFiltersSHEET(filtersSHEET => ({
    ...filtersSHEET,
    marcaTo:  vehicletype.marca || ""
  }));
  setFilteredMarcaTo([]);
  setHighlightedIndexMarcaTo(-1);
  }; 
  const handleKeyDownMarcaTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredMarcaTo.length === 0 && filtersSHEET.marcaTo.trim() === "") {
        const filtered = marcaToSelect.filter(item=>(item.marca>=filtersSHEET.marcaFrom));
        setFilteredMarcaTo(filtered);
        setHighlightedIndexMarcaTo(0);
      } else {
        setHighlightedIndexMarcaTo((prevIndex) => {
          const nextIndex = prevIndex < filteredMarcaTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexMarcaTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexMarcaTo >= 0) {
      if (highlightedIndexMarcaTo >= 0 && highlightedIndexMarcaTo < filteredMarcaTo.length) {
        handleSelectMarcaTo(filteredMarcaTo[highlightedIndexMarcaTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = marcaToSelect
      .filter(item=>(item.marca>=filtersSHEET.marcaFrom))
      .some((vehicletype) => {
      if (!vehicletype || !vehicletype.marca) return false; 
        const normalizedMarca = vehicletype.tradename.toUpperCase();
        const normalizedInputMarca = filtersSHEET.marcaTo.toUpperCase();
        return normalizedMarca === normalizedInputMarca;
    }); 
    if (!isValid) {
      setFiltersSHEET(filtersSHEET => ({
        ...filtersSHEET,
        marcaTo:  ""
      }));
    }
    setFilteredMarcaTo([]);
    setHighlightedIndexMarcaTo(-1);
    }
  }; 
  
  // Dentro del componente
  const debouncedHandleSearchModelFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredModelFrom([]);
      setHighlightedIndexModelFrom(-1);
      return;
    }
    const filtered = modelToSelect
      .filter(vehicletype => vehicletype && vehicletype.model)
      .filter(vehicletype => {
        const model = vehicletype.model.toUpperCase(); 
        return model.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredModelFrom(filtered);
    setHighlightedIndexModelFrom(0);
  }, 300); 
  // Manejo de la selección de una tienda
    const handleSelectModelFrom = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFiltersSHEET(filtersSHEET => ({
      ...filtersSHEET,
      modeloFrom: vehicletype.model || "",
      modeloTo: vehicletype.model || filtersSHEET.modeloTo 
    }));
    setFilteredModelFrom([]);
    setHighlightedIndexModelFrom(-1);
  }; 
 const handleKeyDownModelFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredModelFrom.length === 0 && filtersSHEET.modeloFrom.trim() === "") {
        setFilteredModelFrom(modelToSelect);
        setHighlightedIndexModelFrom(0);
      } else {
        setHighlightedIndexModelFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredModelFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexModelFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexModelFrom >= 0) {
      if (highlightedIndexModelFrom >= 0 && highlightedIndexModelFrom < filteredModelFrom.length) {
        handleSelectModelFrom(filteredModelFrom[highlightedIndexModelFrom]);
      }
    } else if (event.key === "Escape" ) {
      const isValid = modelToSelect.some((vehicletype) => {
        if (!vehicletype || !vehicletype.model) return false; 
        const normalizedModel = vehicletype.model.toUpperCase();
        const normalizedInputModel = filtersSHEET.modeloFrom.toUpperCase();
        return normalizedModel === normalizedInputModel;
      }); 
      if (!isValid) {
        setFiltersSHEET(filtersSHEET => ({
          ...filtersSHEET,
          modelFrom: ""
        }));
      }
      setFilteredModelFrom([]);
      setHighlightedIndexModelFrom(-1);
    }
  };
 
  // Dentro del componente
  const debouncedHandleSearchModelTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredModelTo([]);
      setHighlightedIndexModelTo(-1);
      return;
    }
    const filtered = modelToSelect
      .filter(vehicletype=>(vehicletype.model>=filtersSHEET.modelFrom))
      .filter(vehicletype => vehicletype && vehicletype.model)
      .filter(vehicletype => {
        const model = vehicletype.model.toUpperCase();
        return model.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredModelTo(filtered);
    setHighlightedIndexModelTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectModelTo = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFiltersSHEET(filtersSHEET => ({
    ...filtersSHEET,
    modelTo:  vehicletype.model || ""
  }));
  setFilteredModelTo([]);
  setHighlightedIndexModelTo(-1);
  }; 
  const handleKeyDownModelTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredModelTo.length === 0 && filtersSHEET.modeloTo.trim() === "") {
        const filtered = modelToSelect.filter(item=>(item.model>=filtersSHEET.modelFrom));
        setFilteredModelTo(filtered);
        setHighlightedIndexModelTo(0);
      } else {
        setHighlightedIndexModelTo((prevIndex) => {
          const nextIndex = prevIndex < filteredModelTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexModelTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexModelTo >= 0) {
      if (highlightedIndexModelTo >= 0 && highlightedIndexModelTo < filteredModelTo.length) {
        handleSelectModelTo(filteredModelTo[highlightedIndexModelTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = modelToSelect
      .filter(item=>(item.model>=filtersSHEET.modelFrom))
      .some((vehicletype) => {
      if (!vehicletype || !vehicletype.model) return false; 
        const normalizedModel = vehicletype.tradename.toUpperCase();
        const normalizedInputModel = filtersSHEET.modelTo.toUpperCase();
        return normalizedModel === normalizedInputModel;
    }); 
    if (!isValid) {
      setFiltersSHEET(filtersSHEET => ({
        ...filtersSHEET,
        modeloTo:  ""
      }));
    }
    setFilteredMarcaTo([]);
    setHighlightedIndexMarcaTo(-1);
    }
  }; 
 
  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) { 
      setHighlightedIndexMarcaFrom(-1); 
      setFilteredMarcaFrom([]);
      setHighlightedIndexMarcaTo(-1); 
      setFilteredMarcaTo([]); 
      setHighlightedIndexModelFrom(-1); 
      setFilteredModelFrom([]);
      setHighlightedIndexModelTo(-1); 
      setFilteredModelTo([]);  
    }
  }, []); 
 
  const handleFinishSelectedSHEET = (e) => {
    let isMounted = true;
    if (e.key !== 'Escape') {
      const fetchnumTotRegSHEET = async () => { 
        try {
          const getData  = (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Sheet_Store_Master')))
          ?(typeOfList==="1"?
            await helpHttp().get2(ENDPOINT,`sheet/getinformationtablesheet/`,token,false):
            await helpHttp().get2(ENDPOINT,`sheet/getinformationtablesheet/`,token,true))
              :(typeOfList==="1"
                ?await helpHttp().get7(ENDPOINT,`sheet/getinformationtablesheetwithstore`,token,defaultStore.id,useraccount_id,false)
                :await helpHttp().get7(ENDPOINT,`sheet/getinformationtablesheetwithstore`,token,defaultStore.id,useraccount_id,true))
          if (getData.err || getData.message === "Load failed") {
            if (isMounted) {
              setDataSHEET(initialStateSHEET);
              if (getData.message==="Load failed"){
                dispatch(warningErrorAction(t('Text_ConnectionFailied')));
              }else {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              }   
            }
          } else if (isMounted) {
            setNumTotRegSHEET(getData); 
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      }; 
      const fetchnumTotRegFilter = async () => { 
        try {
          const getData = 
              (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Sheet_Store_Master')))?
              await helpHttp().post4(ENDPOINT,`sheet/getcountfiltersheet`,token,"-1","-1",typeOfList,filtersSHEETDetails):
              await helpHttp().post4(ENDPOINT,`sheet/getcountfiltersheet`,token,"-1",useraccount_id,typeOfList,filtersSHEETDetails)
             
          if (getData.err || getData.message === "Load failed") {
            if (isMounted) {
              setDataSHEET(initialStateSHEET);
              if (getData.message==="Load failed"){
                dispatch(warningErrorAction(t('Text_ConnectionFailied')));
              }else {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } 
            }
          } else if (isMounted) {
            setNumTotRegFilter(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        } 
      }; 
      const fetchDataSHEET = async () => {
        try {
          const getData = 
            (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Sheet_Store_Master')))?
            await helpHttp().post6(ENDPOINT,`sheet/getformssheet`,token,currencyOffsetSHEET,LIMIT_PAGE,"-1","-1",typeOfList,filtersSHEETDetails):
            await helpHttp().post6(ENDPOINT,`sheet/getformssheet`,token,currencyOffsetSHEET,LIMIT_PAGE,"-1",useraccount_id,typeOfList,filtersSHEETDetails);
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setDataSHEET(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }

      };
      const fetchData = async () => {
        dispatch(setLoading(true));
        try {
          const getData = typeOfList==="1"
          ? await helpHttp().put(ENDPOINT, `sheet/finishsheet`, token, dataSHEET)
          :await helpHttp().put(ENDPOINT, `sheet/returnsheet`, token, dataSHEET);
          if (getData.status === "OK") {
            if (isMounted) {
              dispatch(successErrorAction(typeOfList==="1"?t('Text_Finished_SHEET'):t('Text_Pending_SHEET'))); 
              handleCloseDataEditSHEET();
              fetchnumTotRegSHEET();
              fetchnumTotRegFilter();
              fetchDataSHEET();
              dispatch(setLoading(false));
              setRefeshData(true);
            }
          } else {
            if (isMounted) {
              dispatch(warningErrorAction(t(getData.cause)));
            }
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData')));
        }  
      }   
      fetchData(); 
    }
    setOpenDeleteRowSHEET(false);
    setIsLoadingErrorSHEET(false);
    dispatch(setLoading(false));
    handleCloseDataEditSHEET();
  };

  const openEditFiltersSHEET = () => {
    setOpenEditFilterSHEET(!openEditFilterSHEET);
  };

  const handleSubmitFilterEditSHEET = () => {
    setErrorsFiltersSHEET(validateFormFilterSHEET());
    if (Object.keys(errorsFiltersSHEET).length === 0) {
      setErrorsFiltersSHEET({});
      dispatch(resetPagination());
      dispatch(setFilters(filtersSHEET));
      setOpenEditFilterSHEET(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }

  const handleDeleteFiltersSHEET = () => {
    setErrorsFiltersSHEET({});
    dispatch(resetPagination());
    dispatch(resetFilters()); 
    setFiltersSHEET(initialFiltersSHEET);
    setOpenEditFilterSHEET(!openEditFilterSHEET);
  };

  const handleCancelFiltersSHEET = () => {
    setErrorsFiltersSHEET({});
    setOpenEditFilterSHEET(!openEditFilterSHEET);
  };
 
  const handleChangeSelectDateSheetFrom = (event) => {
    setFiltersSHEET(filtersSHEET => ({
      ...filtersSHEET,
      dateSheetFrom: event!==null?new Date(event):null,
      dateSheetTo:null
    }));
  };
 
  const handleBlurSelectDateSheetFrom = (e) => {
    handleChangeSelectDateSheetFrom(e);
    setErrorsFiltersSHEET(validateFormFilterSHEET());
  };

  const handleChangeSelectDateSheetTo = (event) => {
    setFiltersSHEET(filtersSHEET => ({
      ...filtersSHEET,
      dateSheetTo: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectDateSheetTo = (e) => {
    handleChangeSelectDateSheetTo(e);
    setErrorsFiltersSHEET(validateFormFilterSHEET());
  };
   
  const handleChangeFilterEditSHEET = (e) => {
    const { name, value } = e.target;
    setFiltersSHEET(filtersSHEET => ({
      ...filtersSHEET,
      [name]: value
    }));
  };

  const handleBlurFilterEditSHEET = (e) => {
    setErrorsFiltersSHEET(validateFormFilterSHEET());
    handleChangeFilterEditSHEET(e);
  };

  const toggleDrawerFilterEditSHEET = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditSHEET();
    }
  };

  const validateFormFilterSHEET = () => {

    let errorsFiltersSHEET = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersSHEET.idFrom!=="" & !regexNumber.test(filtersSHEET.idFrom)) {
      errorsFiltersSHEET.idFrom = 'Text_TextNoNumber';
    }
    if (filtersSHEET.idTo!=="" & !regexNumber.test(filtersSHEET.idTo)) {
      errorsFiltersSHEET.idTo = 'Text_TextNoNumber';
    }
    if (filtersSHEET.idFrom!=="" & !errorsFiltersSHEET.idFrom!==undefined){
      if (filtersSHEET.idTo!=="" & !errorsFiltersSHEET.idTo!==undefined){
        if (parseInt(filtersSHEET.idTo)<parseInt(filtersSHEET.idFrom)){
          errorsFiltersSHEET.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (regexInvalidCharacters.test(filtersSHEET.numberSheetFrom)) {
      errorsFiltersSHEET.numberSheetFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersSHEET.numberSheetTo)) {
      errorsFiltersSHEET.numberSheetTo = 'Text_TextNoValid';
    }
      
    if (regexInvalidCharacters.test(filtersSHEET.marcaFrom)) {
      errorsFiltersSHEET.marcaFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersSHEET.marcaTo)) {
      errorsFiltersSHEET.marcaTo = 'Text_TextNoValid';
    }

    if (regexInvalidCharacters.test(filtersSHEET.modeloFrom)) {
      errorsFiltersSHEET.modeloFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersSHEET.modeloTo)) {
      errorsFiltersSHEET.modeloTo = 'Text_TextNoValid';
    }

    if (regexInvalidCharacters.test(filtersSHEET.licensePlateSheetFrom)) {
      errorsFiltersSHEET.licensePlateSheetFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersSHEET.licensePlateSheetTo)) {
      errorsFiltersSHEET.licensePlateSheetTo = 'Text_TextNoValid';
    }

     if (regexInvalidCharacters.test(filtersSHEET.frameSheetFrom)) {
      errorsFiltersSHEET.frameSheetFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersSHEET.frameSheetTo)) {
      errorsFiltersSHEET.frameSheetTo = 'Text_TextNoValid';
    }
 
    if (filtersSHEET.defaultStoreIdTo!=="" & filtersSHEET.defaultStoreIdTo<filtersSHEET.defaultStoreIdFrom){
      errorsFiltersSHEET.defaultStoreIdTo = 'Text_TextGreater_Store';
    }

    if (filtersSHEET.useraccountIdTo!=="" & filtersSHEET.useraccountIdTo<filtersSHEET.useraccountIdFrom){
      errorsFiltersSHEET.useraccountIdTo = 'Text_TextGreater_UserAccount';
    }

    if (filtersSHEET.sheetStateToES!=="" & filtersSHEET.sheetStateToES<filtersSHEET.sheetStateFromES){
      filtersSHEET.sheetStateToES="";
      errorsFiltersSHEET.sheetStateToES = 'Text_TextGreater_SheetStatus';
    }    
    if (filtersSHEET.sheetStateToEN!=="" & filtersSHEET.sheetStateToEN<filtersSHEET.sheetStateFromES){
        filtersSHEET.sheetStateToEN="";
        errorsFiltersSHEET.sheetStateToEN = 'Text_TextGreater_SheetStatus';
    }

    if (filtersSHEET.numberSheetTo!=="" & filtersSHEET.numberSheetTo<filtersSHEET.numberSheetFrom){
      errorsFiltersSHEET.numberSheetTo = 'Text_TextGreater_NumberSheet';
    }

     if (filtersSHEET.marcaTo!=="" & filtersSHEET.marcaTo<filtersSHEET.marcaFrom){
      errorsFiltersSHEET.marcaTo = 'Text_TextGreater_MarcaSheet';
    }

    if (filtersSHEET.modeloTo!=="" & filtersSHEET.modeloTo<filtersSHEET.modeloFrom){
      errorsFiltersSHEET.modeloTo = 'Text_TextGreater_ModelSheet';
    }

    if (filtersSHEET.licensePlateSheetTo!=="" & filtersSHEET.licensePlateSheetTo<filtersSHEET.licensePlateSheetFrom){
      errorsFiltersSHEET.licensePlateSheetTo = 'Text_TextGreater_LicensePlateSheet';
    }

    if (filtersSHEET.frameSheetTo!=="" & filtersSHEET.frameSheetTo<filtersSHEET.frameSheetFrom){
      errorsFiltersSHEET.frameSheetTo = 'Text_TextGreater_FrameSheet';
    }

    return errorsFiltersSHEET;
  }  

  const filteredDataSHEET = dataSHEET.filter((el) => {
    if (inputTextSHEET === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') + 
        String(el.num_sheet || '') + 
        String(el.vehicle_marca || '') + 
        String(el.vehicle_model || '') + 
        String(el.vehicle_sheet || '') +  
        String(el.frame_sheet || '');
      let result = dataTranslate.toLowerCase().includes(inputTextSHEET.toLowerCase());
      return result; 
    }
  })

  let inputHandlerSHEET = (e) => {
      var lowerCase = e.target.value.toLowerCase();
      setInputTextSHEET(lowerCase);
  };

  const handleChangeDeleteRowSHEET = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };

  const handleCancelDeleteRowSHEET = () => {
    setRowEditSHEET(initialStateSHEET[0]);
    setIsLoadingErrorSHEET(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowSHEET(false);
  };

  const handleCloseDeleteRowSHEET = (e) => {
    if (idCodeDelete !== DELETE_CODE_FORMDI) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    let isMounted = true;
    if (e.key !== 'Escape') {
      if (rowEditSHEET.id!=='') {      
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT,`sheet/deletesheet`,token,rowEditSHEET);
            if (getData.status === "OK") {
              if (isMounted) {
                dispatch(successErrorAction(t('Text_ValidCode')));
                dispatch(successErrorAction(t('Text_DeleteField')));
                setRefeshData(true);
                handleCloseDataEditSHEET(); 
              }
            } else {
              if (isMounted) {
                dispatch(warningErrorAction(t(getData.cause)));
              }
            }
            dispatch(setLoading(false));
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          } 
        };
        fetchData();
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    }
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowSHEET(false);
    setIsLoadingErrorSHEET(false);
    handleCloseDataEditSHEET(); 
  };

  const handleCloseDataEditSHEET = () => { 
    setOpenEditRowSHEET(false);
    setRowEditSHEET(openEditRowSHEET?rowEditSHEET:initialStateSHEET[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorSHEET(false);
    toggleDrawerFilterEditSHEET(false);  
    setRefeshData(false);
	};
  
  useEffect(() => {
    if (numTotRegSHEET > Number(LIMIT_PAGE)) {
      setActiveOffsetSHEET(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMIT_PAGE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMIT_PAGE); i < numTotRegSHEET; i += Number(LIMIT_PAGE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffsetSHEET(newRangeOffset);
    } else {
      setCurrencyOffsetSHEET(0);
      setActiveOffsetSHEET(false);
      setRangeOffsetSHEET([{}]);
    }
  }, [numTotRegSHEET]);
  
  useEffect(() => {
    if (showModalSHEEETSettings){
      setFormSHEET(formSHEET => ({
        ...formSHEET,
        id : rowEditSHEET.id!==null?rowEditSHEET.id:"",
        defaultStore_id : rowEditSHEET.defaultStore_id!==null?rowEditSHEET.defaultStore_id:0,
        useraccount_id :rowEditSHEET.useraccount_id!==null?rowEditSHEET.useraccount_id:0,
        num_sheet :rowEditSHEET.num_sheet!==null?rowEditSHEET.num_sheet:"",
        date_sheet :rowEditSHEET.date_sheet!==null?rowEditSHEET.date_sheet:"",
        vehicle_marca :rowEditSHEET.vehicle_marca!==null?rowEditSHEET.vehicle_marca:"",
        vehicle_model :rowEditSHEET.vehicle_model!==null?rowEditSHEET.vehicle_model:"",
        vehicle_sheet :rowEditSHEET.vehicle_sheet!==null?rowEditSHEET.vehicle_sheet:"",
        frame_sheet :rowEditSHEET.frame_sheet!==null?rowEditSHEET.frame_sheet:"",
        sheetStatus_id :rowEditSHEET.sheetStatus_id!==null?rowEditSHEET.sheetStatus_id:1,
        sheetStatus_namees :rowEditSHEET.sheetStatus_namees!==null?rowEditSHEET.sheetStatus_namees:"",
        sheetStatus_nameen :rowEditSHEET.sheetStatus_nameen!==null?rowEditSHEET.sheetStatus_nameen:"",
        isFinished :rowEditSHEET.isFinished!==null?rowEditSHEET.isFinished:false
      }));
    }else{
      setFormSHEET(initialStateSHEET[0]);
    }
  },[rowEditSHEET,showModalSHEEETSettings]);

  const handleExport = () => { 
      const fetchDataSheet = async () => {
        dispatch(setLoading(true));
        try {
        const getData = 
          (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Sheet_Store_Master')))?
          await helpHttp().post6(ENDPOINT,`sheet/getsheettoexcel`,token,currencyOffsetSHEET,LIMIT_PAGE,"-1","-1",typeOfList,filtersSHEETDetails):
          await helpHttp().post6(ENDPOINT,`sheet/getsheettoexcel`,token,currencyOffsetSHEET,LIMIT_PAGE,"-1",useraccount_id,typeOfList,filtersSHEETDetails);
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (getData && getData.length>0) {
            exportSHEETToExcel(getData, "FICHAS_DESCONTAMINACIÓN"); 
          }
          dispatch(setLoading(false)); 
        } catch (error) {
          dispatch(setLoading(false)); 
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      };
  
      if (dataSHEET && dataSHEET.length>0){ 
        fetchDataSheet();
      } 
    };
    

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataVehiclesMarca = async () => {
      try {
        const getData = await helpHttp().get7(ENDPOINT,`sheet/getlistvehicletypesmarca`,token,
          filtersSHEET.marcaFrom!==undefined && filtersSHEET.marcaFrom!==null && filtersSHEET.marcaFrom.replace(/[.\-/\\|]/g, "").trim()!==""?filtersSHEET.marcaFrom.replace(/[.\-/\\|]/g, ""):"-1",
          filtersSHEET.marcaTo!==undefined && filtersSHEET.marcaTo!==null && filtersSHEET.marcaTo.replace(/[.\-/\\|]/g, "").trim()!==""?filtersSHEET.marcaTo.replace(/[.\-/\\|]/g, ""):"-1",
          (typeOfList==="1")?false:true); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setMarcaToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   
    if (showModalSHEEETSettings ) { 
      fetchDataVehiclesMarca();
    }
    return () => { isMounted = false };

  }, [t,token,dispatch,i18n,roles,filtersSHEET,openEditFilterSHEET,showModalSHEEETSettings,typeOfList]);
   
  useEffect(() => {
    let isMounted = true; 
    const fetchDataVehiclesMarca = async () => {
      try {
        const getData = await helpHttp().get7(ENDPOINT,`sheet/getlistvehicletypesmodel`,token,
          filtersSHEET.modeloFrom!==undefined && filtersSHEET.modeloFrom!==null && filtersSHEET.modeloFrom.replace(/[.\-/\\|]/g, "").trim()!==""?filtersSHEET.modeloFrom.replace(/[.\-/\\|]/g, ""):"-1",
          filtersSHEET.modeloTo!==undefined && filtersSHEET.modeloTo!==null && filtersSHEET.modeloTo.replace(/[.\-/\\|]/g, "").trim()!==""?filtersSHEET.modeloTo.replace(/[.\-/\\|]/g, ""):"-1",
          (typeOfList==="1")?false:true); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setModelToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   
    if (showModalSHEEETSettings) { 
      fetchDataVehiclesMarca();
    }
    return () => { isMounted = false };

  }, [t,token,dispatch,i18n,roles,filtersSHEET,openEditFilterSHEET,showModalSHEEETSettings,typeOfList]);
   
  useEffect(() => {
    let isMounted = true;  
    const fetchDataSheetStatus = async () => {
      try {
        const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `sheetstatus/simplesheetstatusbynamees`, token)
          : await helpHttp().get(ENDPOINT, `sheetstatus/simplesheetstatusbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setSheetStateToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    const fetchDataStore = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`linessheet/storesorderbytradename`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setStoresToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
     
    if (showModalSHEEETSettings || refeshData || reloadRefreshData){
      dispatch(setReloadRefreshData(false));
      setRefeshData(false);
      if (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Sheet_Store_Master'))){
        fetchDataStore();
      }  
      fetchDataSheetStatus(); 
    }  
    return () => { isMounted = false; };
  }, [t,roles,token,dispatch,i18n.language,typeOfList,showModalSHEEETSettings,defaultStore.id,refeshData ,reloadRefreshData,]);
 
  useEffect(() => {
    let isMounted = true;
    const fetchnumTotRegSHEET = async () => { 
      try {
        const getData  = (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Sheet_Store_Master')))
        ?(typeOfList==="1"?
          await helpHttp().get2(ENDPOINT,`sheet/getinformationtablesheet/`,token,false):
          await helpHttp().get2(ENDPOINT,`sheet/getinformationtablesheet/`,token,true))
        :(typeOfList==="1"
              ?await helpHttp().get7(ENDPOINT,`sheet/getinformationtablesheetwithstore`,token,defaultStore.id,"-1",false)
              :await helpHttp().get7(ENDPOINT,`sheet/getinformationtablesheetwithstore`,token,defaultStore.id,"-1",true));
            
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataSHEET(initialStateSHEET);
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            }  
          }
          
        } else if (isMounted) {
          setNumTotRegSHEET(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }   
    }; 
    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = 
            (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Sheet_Store_Master')))?
            await helpHttp().post4(ENDPOINT,`sheet/getcountfiltersheet`,token,"-1","-1",typeOfList,filtersSHEETDetails):
            await helpHttp().post4(ENDPOINT,`sheet/getcountfiltersheet`,token,"-1",useraccount_id,typeOfList,filtersSHEETDetails);
          
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataSHEET(initialStateSHEET);
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } 
          }
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };  
    const fetchDataSHEET = async () => {
       dispatch(setLoading(true));
      try {
        const getData = 
          (roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Sheet_Store_Master')))?
          await helpHttp().post6(ENDPOINT,`sheet/getformssheet`,token,currencyOffsetSHEET,LIMIT_PAGE,"-1","-1",typeOfList,filtersSHEETDetails):
          await helpHttp().post6(ENDPOINT,`sheet/getformssheet`,token,currencyOffsetSHEET,LIMIT_PAGE,"-1",useraccount_id,typeOfList,filtersSHEETDetails);
        if (getData.err) {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataSHEET(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
 
    if (showModalSHEEETSettings || refeshData){
      fetchnumTotRegSHEET();
      fetchnumTotRegFilter();
      fetchDataSHEET();
      setRefeshData(false); 
    }  
    return () => { isMounted = false; };
  }, [t,roles,token,dispatch,i18n.language,typeOfList,showModalSHEEETSettings,currencyOffsetSHEET,defaultStore.id,useraccount_id ,openDeleteRowSHEET,setOpenDeleteRowSHEET,setOpenEditRowSHEET,openEditRowSHEET,rowEditSHEET,defaultStore, filtersSHEETDetails,refeshData]);

  return (
    <>
      {showModalSHEEETSettings ? ( 
        <div className="container-fluid formdi-pending-page">
          {/* Search input */}
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">{isLoadingErrorSHEET ?(<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>) : isLoadingData ? ( <CircularProgress color={openDeleteRowSHEET ? "warning" : "primary"} />) : (<i className="fas fa-regular fa-clipboard text-warning"></i>)}{" "} {typeOfList === "1" ? t("Text_SHEET_Table") : t("Text_SHEET_ENDED")}</h1>
              {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_Ended'))? (
              <div>
                <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleFinishSelectedSHEET} >
                  {typeOfList === "1" ? t("Button_Finish_SHEET") : t("Button_Pending_SHEET")}
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalSHEET} >
                  {t("Button_Back")}
                </button>
              </div>
            ) : (
              <div>
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary" onClick={closeModalSHEET} >
                  {t("Button_Back")}
                </button>
              </div>
            )} 
          </div>  
          <br/> 
          <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={inputTextSHEET}
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              placeholder={t('Text_SHEET_Search')} 
              onChange={inputHandlerSHEET}
              fullWidth
              label={t('Text_SHEET_Search')}>
            </TextField>
          </div>
          <br/>
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${filtersSHEETDetails.idFrom !== "" || filtersSHEETDetails.idTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersSHEET} >
                <span className={`formdi-pending-dot ${ filtersSHEETDetails.idFrom !== "" || filtersSHEETDetails.idTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Code")}
              </button>
              {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Sheet_Store_Master"))&& (
                <button type="button" className={`formdi-pending-chip ${filtersSHEETDetails.defaultStoreIdFrom !== "" || filtersSHEETDetails.defaultStoreIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersSHEET} >
                  <span className={`formdi-pending-dot ${ filtersSHEETDetails.defaultStoreIdFrom !== "" || filtersSHEETDetails.defaultStoreIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_Store")}
                </button> 
              )} 
              <button type="button" className={`formdi-pending-chip ${filtersSHEETDetails.dateSheetFrom !== null || filtersSHEETDetails.dateSheetTo !== null ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersSHEET} >
                <span className={`formdi-pending-dot ${ filtersSHEETDetails.dateSheetFrom !== null || filtersSHEETDetails.dateSheetTo !== null? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_SHEET_DATE")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersSHEETDetails.numberSheetFrom !== "" || filtersSHEETDetails.numberSheetTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersSHEET} >
                <span className={`formdi-pending-dot ${ filtersSHEETDetails.numberSheetFrom !== "" || filtersSHEETDetails.numberSheetTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_SHEET_NUM")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersSHEETDetails.marcaFrom !== "" || filtersSHEETDetails.marcaTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersSHEET} >
                <span className={`formdi-pending-dot ${ filtersSHEETDetails.marcaFrom !== "" || filtersSHEETDetails.marcaTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_SHEET_MARCA")}
              </button>
              <button type="button" className={`formdi-pending-chip ${filtersSHEETDetails.modeloFrom !== "" || filtersSHEETDetails.modeloTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersSHEET} >
                <span className={`formdi-pending-dot ${ filtersSHEETDetails.modeloFrom !== "" || filtersSHEETDetails.modeloTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_SHEET_MODEL")}
              </button>
              <button type="button" className={`formdi-pending-chip ${filtersSHEETDetails.licensePlateSheetFrom !== "" || filtersSHEETDetails.licensePlateSheetTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersSHEET} >
                <span className={`formdi-pending-dot ${ filtersSHEETDetails.licensePlateSheetFrom !== "" || filtersSHEETDetails.licensePlateSheetTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_SHEET_LICENSEPLATE")}
              </button>
              <button type="button" className={`formdi-pending-chip ${filtersSHEETDetails.frameSheetFrom !== "" || filtersSHEETDetails.frameSheetTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersSHEET} >
                <span className={`formdi-pending-dot ${ filtersSHEETDetails.frameSheetFrom !== "" || filtersSHEETDetails.frameSheetTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_SHEET_FRAME")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${
                    filtersSHEETDetails.sheetStateFromES!== ""
                    || filtersSHEETDetails.sheetStateToES!== ""
                    || filtersSHEETDetails.sheetStateFromEN!== ""
                    || filtersSHEETDetails.sheetStateToEN!== ""
                     ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersSHEET} >
                <span className={`formdi-pending-dot ${ 
                   filtersSHEETDetails.sheetStateFromES!== ""
                    || filtersSHEETDetails.sheetStateToES!== ""
                    || filtersSHEETDetails.sheetStateFromEN!== ""
                    || filtersSHEETDetails.sheetStateToEN!== "" ? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_SHEET_STATUS")}
              </button>
              {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Sheet_Handle_Excel"))&&
                <>
                  <button type="button" className="formdi-excel-chip" onClick={handleExport}>{t('Button_Excel')}</button><> </> 
                </>
              }       
            </div>
          </div>
          <br/> 
         
          {!isLoadingData ?
            <>
              <div className="formdi-pending-card-flat">
                <div className="formdi-pending-card-content">
                  <TableSortingSHEET
                    dataSHEET={filteredDataSHEET}
                    setDataSHEET={setDataSHEET}
                    setFormSHEET={setFormSHEET}
                    numTotRegFilter={ numTotRegFilter}
                    titleTable={typeOfList==="1"?t('Text_SHEET_Table_Pending'):t('Text_SHEET_Table_ENDED')}
                    setOpenDeleteRowSHEET={setOpenDeleteRowSHEET} 
                    setRowEditSHEET={setRowEditSHEET}
                    showFinishButtonSHEET={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Sheet_Edit_Ended'))?true:false}
                    showEditButtonSHEET={roles[0].listmenus.find((key)=>(key.name==='Handle_Modify_Sheet'))?true:false}
                    showPrintButtonSHEET={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Sheet_Print'))?true:true}
                    showDeleteButtonSHEET={roles[0].listmenus.find((key)=>(key.name==='Handle_Delete_Sheet'))?true:false}
                    showStoreSHEET={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Sheet_Store_Master'))?true:false}
                    numTotRegSHEET={numTotRegSHEET}
                    activeOffsetSHEET={activeOffsetSHEET}
                    rangeOffsetSHEET={rangeOffsetSHEET}
                    currencyOffsetSHEET={currencyOffsetSHEET}
                    setCurrencyOffsetSHEET={setCurrencyOffsetSHEET}
                    typeOfList={typeOfList}
                    setViewPDF={setViewPDF}
                    formSHEET={formSHEET}>
                  </TableSortingSHEET>
                </div>             
              </div>
              
              {openEditFilterSHEET &&
               <div>
               <SwipeableDrawer
                 anchor='right'
                 open={true}
                 onClose={toggleDrawerFilterEditSHEET(false)}
                 onOpen={toggleDrawerFilterEditSHEET(true)}>
                 <Container >
                   <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                     <br/>
                       <div id="myDIV">
                         <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                       </div>
                       <hr className="sidebar-divider d-none d-md-block"/>
                       <form className="createfiltsheet" onSubmit={handleCancelFiltersSHEET}>  
                         <div className="form-floating mb-3 px-4 primary">
                           <div className="form-group">
                             <TextField
                              id="idFrom" 
                              name="idFrom"
                              value={filtersSHEET.idFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersSHEET.idFrom!=null?t(errorsFiltersSHEET.idFrom):t('Text_Filter_Code_From')}
                              placeholder={t('PlaceHolder_Filter_Code_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditSHEET}
                              onChange={handleChangeFilterEditSHEET}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                             <TextField
                              id="idTo" 
                              name="idTo"
                              value={filtersSHEET.idTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersSHEET.idTo!=null?t(errorsFiltersSHEET.idTo):t('Text_Filter_Code_To')}
                              placeholder={t('PlaceHolder_Filter_Code_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditSHEET}
                              onChange={handleChangeFilterEditSHEET}/>
                           </div>
                           {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Sheet_Store_Master'))   &&
                              <>
                                <Suspense delayMs={500} fallback={<CircularProgress sx={{ color :"#f6c23e"}}/>}>
                                  <div className="form-group">
                                    <TextField
                                      id="defaultStoreIdFrom"
                                      name="defaultStoreIdFrom"
                                      value={filtersSHEET.defaultStoreIdFrom}
                                      inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsFiltersSHEET.defaultStoreIdFrom!=null?t(errorsFiltersSHEET.defaultStoreIdFrom):t('Text_Filter_tradename_From')}
                                      placeholder={t('PlaceHolder_Filter_tradename_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditSHEET}
                                      onChange={handleChangeFilterEditSHEET}
                                      select
                                      SelectProps={{
                                      native: true,
                                      }}>
                                      <option key={0} value=""/>
                                      {storesToSelect.map((option) => (
                                          <option key={option.id} value={option.id}>
                                             {option.documentid+" - "+option.tradename}
                                          </option>
                                      ))}
                                    </TextField>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                        id="defaultStoreIdTo"
                                        name="defaultStoreIdTo"
                                        value={filtersSHEET.defaultStoreIdTo}  
                                        inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                        label={errorsFiltersSHEET.defaultStoreIdTo!=null?t(errorsFiltersSHEET.defaultStoreIdTo):t('Text_Filter_tradename_To')}
                                        placeholder={t('PlaceHolder_Filter_tradename_to')}
                                        variant="outlined"
                                        onBlur={handleBlurFilterEditSHEET}
                                        onChange={handleChangeFilterEditSHEET}
                                        select
                                        SelectProps={{
                                        native: true,
                                        }}>
                                         <option key={0} value=""/>
                                        {storesToSelect.filter(item=>(item.id>=filtersSHEET.defaultStoreIdFrom)).map(option => (
                                          <option key={option.id} value={option.id}>
                                              {option.documentid+" - "+option.tradename}
                                          </option>
                                        ))}
                                      </TextField>
                                    </div>
                                </Suspense>
                            </>
                           }   
                           <div className="form-group">
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <DesktopDatePicker
                                id="dateSheetFrom" 
                                name="dateSheetFrom"
                                value={ filtersSHEET.dateSheetFrom!== null ? new Date(filtersSHEET.dateSheetFrom): null}
                                format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                label={errorsFiltersSHEET.dateSheetFrom!=null?t(errorsFiltersSHEET.dateSheetFrom):t('PlaceHolder_Filter_DateEntrySheet_From')}
                                onBlur={handleBlurSelectDateSheetFrom}
                                onChange={handleChangeSelectDateSheetFrom}
                                slotProps={{
                                  textField: {
                                    placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                    sx: {
                                      color: '#1565c0',
                                      maxLength: '100',
                                      width: 430,  
                                      fontSize: '18px'
                                    },
                                    InputProps: {
                                      style: {
                                        fontSize: '18px',
                                      }
                                    },
                                    InputLabelProps:{ 
                                      style: {
                                        fontSize: '18px', 
                                        background: '#FFFFFF'
                                      }
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <DesktopDatePicker
                                id="dateSheetTo" 
                                name="dateSheetTo"
                                minDate={filtersSHEET.dateSheetFrom!== null ? new Date(filtersSHEET.dateSheetFrom): null}
                                value={ filtersSHEET.dateSheetTo!== null ? new Date(filtersSHEET.dateSheetTo): null}
                                format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                label={errorsFiltersSHEET.dateSheetTo!=null?t(errorsFiltersSHEET.dateSheetTo):t('PlaceHolder_Filter_DateEntrySheet_To')}
                                onBlur={handleBlurSelectDateSheetTo}
                                onChange={handleChangeSelectDateSheetTo}
                                slotProps={{
                                  textField: {
                                    placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                    sx: {
                                      color: '#1565c0',
                                      maxLength: '100',
                                      width: 430,  
                                      fontSize: '18px'
                                    },
                                    InputProps: {
                                      style: {
                                        fontSize: '18px',
                                      }
                                    },
                                    InputLabelProps:{ 
                                      style: {
                                        fontSize: '18px', 
                                        background: '#FFFFFF'
                                      }
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </div>
                          <div className="form-group">
                             <TextField
                              id="numberSheetFrom" 
                              name="numberSheetFrom"
                              value={filtersSHEET.numberSheetFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFiltersSHEET.numberSheetFrom!=null?t(errorsFiltersSHEET.numberSheetFrom):t('Text_Filter_NumberSheet_From')}
                              placeholder={t('PlaceHolder_Filter_NumberSheet_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditSHEET}
                              onChange={handleChangeFilterEditSHEET}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                             <TextField
                              id="numberSheetTo" 
                              name="numberSheetTo"
                              value={filtersSHEET.numberSheetTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFiltersSHEET.numberSheetTo!=null?t(errorsFiltersSHEET.numberSheetTo):t('Text_Filter_NumberSheet_To')}
                              placeholder={t('PlaceHolder_Filter_NumberSheet_To')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditSHEET}
                              onChange={handleChangeFilterEditSHEET}/>
                           </div>
                           
                            <div className="form-group">
                              <span style={{ position: "relative" }}>
                                <TextField
                                  id="marcaFrom"
                                  name="marcaFrom"
                                  value={filtersSHEET.marcaFrom}
                                  onChange={(e) => {
                                    setFiltersSHEET(prev => ({
                                      ...prev,
                                      marcaFrom: e.target.value.toUpperCase(),
                                      marcaTo: e.target.value.toUpperCase()
                                    }));
                                    debouncedHandleSearchMarcaFrom(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownMarcaFrom}
                                  onBlur={(event) => {
                                    if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                    }
                                  }}
                                  label={errorsFiltersSHEET.marcaFrom != null
                                    ? t(errorsFiltersSHEET.marcaFrom)
                                    : t('Text_Filter_MarcaSheet_From')}
                                  placeholder={t('PlaceHolder_Filter_MarcaSheet_From')}
                                  inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                  InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                  variant="outlined"
                                />
                                {filteredMarcaFrom.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left: '0px',
                                      border: "2px solid #4e73df",
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: '18px',
                                      backgroundColor: "#f8f9fa",
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()}
                                  >
                                    {filteredMarcaFrom.map((vehicletype, index) => (
                                      <MenuItem
                                        key={vehicletype.id}
                                        onClick={() => handleSelectMarcaFrom(vehicletype)}
                                        style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: '18px',
                                          backgroundColor: index === highlightedIndexMarcaFrom ? "#4e73df" : "transparent",
                                          color: index === highlightedIndexMarcaFrom ? "white" : "black",
                                        }}
                                      >
                                        {vehicletype.marca}
                                      </MenuItem>
                                    ))}
                                  </div>
                                )} 
                                </span>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <span style={{ position: "relative" }} >
                                  <TextField
                                    id="marcaTo"
                                    name="marcaTo"
                                    value={filtersSHEET.marcaTo}
                                    onChange={(e) => {
                                      setFiltersSHEET(prev => ({
                                        ...prev,
                                        marcaTo: e.target.value.toUpperCase()
                                      }));
                                      debouncedHandleSearchMarcaTo(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownMarcaTo}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsFiltersSHEET.marcaTo != null
                                      ? t(errorsFiltersSHEET.marcaTo)
                                      : t('PlaceHolder_Filter_MarcaSheet_To')}
                                    placeholder={t('PlaceHolder_Filter_MarcaSheet_To')}
                                    inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                    variant="outlined"
                                />
                                {filteredMarcaTo.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left: '0px',
                                      border: "2px solid #4e73df",
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: '18px',
                                      backgroundColor: "#f8f9fa",
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()}
                                  >
                                    {filteredMarcaTo.map((vehicletype, index) => (
                                      <MenuItem
                                        key={vehicletype.id}
                                        onClick={() => handleSelectMarcaTo(vehicletype)}
                                        style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: '18px',
                                          backgroundColor: index === highlightedIndexMarcaTo ? "#4e73df" : "transparent",
                                          color: index === highlightedIndexMarcaTo ? "white" : "black",
                                        }}
                                      >
                                        {vehicletype.marca} 
                                      </MenuItem>
                                    ))}
                                  </div>
                                )}
                              </span>  
                           </div>

                           <div className="form-group">
                              <span style={{ position: "relative" }}>
                                <TextField
                                  id="modeloFrom"
                                  name="modeloFrom"
                                  value={filtersSHEET.modeloFrom}
                                  onChange={(e) => {
                                    setFiltersSHEET(prev => ({
                                      ...prev,
                                      modeloFrom: e.target.value.toUpperCase(),
                                      modeloTo: e.target.value.toUpperCase()
                                    }));
                                    debouncedHandleSearchModelFrom(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownModelFrom}
                                  onBlur={(event) => {
                                    if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                    }
                                  }}
                                  label={errorsFiltersSHEET.modeloFrom != null
                                    ? t(errorsFiltersSHEET.modeloFrom)
                                    : t('Text_Filter_ModelSheet_From')}
                                  placeholder={t('PlaceHolder_Filter_ModelSheet_From')}
                                  inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                  InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                  variant="outlined"
                                />
                                {filteredModelFrom.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left: '0px',
                                      border: "2px solid #4e73df",
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: '18px',
                                      backgroundColor: "#f8f9fa",
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()}
                                  >
                                    {filteredModelFrom.map((vehicletype, index) => (
                                      <MenuItem
                                        key={vehicletype.id}
                                        onClick={() => handleSelectModelFrom(vehicletype)}
                                        style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: '18px',
                                          backgroundColor: index === highlightedIndexModelFrom ? "#4e73df" : "transparent",
                                          color: index === highlightedIndexModelFrom ? "white" : "black",
                                        }}
                                      >
                                        {vehicletype.model}
                                      </MenuItem>
                                    ))}
                                  </div>
                                )} 
                                </span>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <span style={{ position: "relative" }} >
                                  <TextField
                                    id="modeloTo"
                                    name="modeloTo"
                                    value={filtersSHEET.modeloTo}
                                    onChange={(e) => {
                                      setFiltersSHEET(prev => ({
                                        ...prev,
                                        modeloTo: e.target.value.toUpperCase()
                                      }));
                                      debouncedHandleSearchModelTo(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownModelTo}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsFiltersSHEET.modeloTo != null
                                      ? t(errorsFiltersSHEET.modeloTo)
                                      : t('PlaceHolder_Filter_ModelSheet_To')}
                                    placeholder={t('PlaceHolder_Filter_ModelSheet_To')}
                                    inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                    variant="outlined"
                                />
                                {filteredModelTo.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left: '0px',
                                      border: "2px solid #4e73df",
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: '18px',
                                      backgroundColor: "#f8f9fa",
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()}
                                  >
                                    {filteredModelTo.map((vehicletype, index) => (
                                      <MenuItem
                                        key={vehicletype.id}
                                        onClick={() => handleSelectModelTo(vehicletype)}
                                        style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: '18px',
                                          backgroundColor: index === highlightedIndexModelTo ? "#4e73df" : "transparent",
                                          color: index === highlightedIndexModelTo ? "white" : "black",
                                        }}
                                      >
                                        {vehicletype.model} 
                                      </MenuItem>
                                    ))}
                                  </div>
                                )}
                              </span>  
                           </div>

                           <div className="form-group">
                             <TextField
                              id="licensePlateSheetFrom" 
                              name="licensePlateSheetFrom"
                              value={filtersSHEET.licensePlateSheetFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}   
                              label={errorsFiltersSHEET.licensePlateSheetFrom!=null?t(errorsFiltersSHEET.licensePlateSheetFrom):t('Text_Filter_LicensePlateSheet_From')}
                              placeholder={t('PlaceHolder_Filter_LicensePlateSheet_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditSHEET}
                              onChange={handleChangeFilterEditSHEET}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                             <TextField
                              id="licensePlateSheetTo" 
                              name="licensePlateSheetTo"
                              value={filtersSHEET.licensePlateSheetTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}   
                              label={errorsFiltersSHEET.licensePlateSheetTo!=null?t(errorsFiltersSHEET.licensePlateSheetTo):t('Text_Filter_LicensePlateSheet_To')}
                              placeholder={t('PlaceHolder_Filter_LicensePlateSheet_To')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditSHEET}
                              onChange={handleChangeFilterEditSHEET}/>
                           </div>

                            <div className="form-group">
                             <TextField
                              id="frameSheetFrom" 
                              name="frameSheetFrom"
                              value={filtersSHEET.frameSheetFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}   
                              label={errorsFiltersSHEET.frameSheetFrom!=null?t(errorsFiltersSHEET.frameSheetFrom):t('Text_Filter_FrameSheet_From')}
                              placeholder={t('PlaceHolder_Filter_FrameSheet_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditSHEET}
                              onChange={handleChangeFilterEditSHEET}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                             <TextField
                              id="frameSheetTo" 
                              name="frameSheetTo"
                              value={filtersSHEET.frameSheetTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}   
                              label={errorsFiltersSHEET.frameSheetTo!=null?t(errorsFiltersSHEET.frameSheetTo):t('Text_Filter_FrameSheet_To')}
                              placeholder={t('PlaceHolder_Filter_FrameSheet_To')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditSHEET}
                              onChange={handleChangeFilterEditSHEET}/>
                           </div>

                            <div className="form-group">
                              <TextField
                                id={i18n.language==="es"?"sheetStateFromES":"sheetStateFromEN"}
                                name={i18n.language==="es"?"sheetStateFromES":"sheetStateFromEN"}
                                value={i18n.language==="es"?filtersSHEET.sheetStateFromES:filtersSHEET.sheetStateFromEN}
                                inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={i18n.language==="es"?errorsFiltersSHEET.sheetStateFromES!=null?t(errorsFiltersSHEET.languageFromES):t('Text_Filter_SheetStatus_From'):errorsFiltersSHEET.sheetStateFromEN!=null?t(errorsFiltersSHEET.sheetStateFromEN):t('Text_Filter_SheetStatus_From')}
                                placeholder={t('PlaceHolder_Filter_SheetStatus_From')}
                                variant="outlined"
                                onBlur={handleBlurFilterEditSHEET}
                                onChange={handleChangeFilterEditSHEET}
                                select
                                SelectProps={{
                                native: true,
                                }}>
                                <option key={0} value=""/>
                                {sheetStateToSelect.map((option) => (
                                <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </option>
                                ))}
                              </TextField>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <TextField
                                  id={i18n.language==="es"?"sheetStateToES":"sheetStateToEN"}
                                  name={i18n.language==="es"?"sheetStateToES":"sheetStateToEN"}
                                  value={i18n.language==="es"?filtersSHEET.sheetStateToES:filtersSHEET.sheetStateToEN}
                                  inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  label={i18n.language==="es"?errorsFiltersSHEET.sheetStateToES!=null?t(errorsFiltersSHEET.sheetStateToES):t('Text_Filter_SheetStatus_To'):errorsFiltersSHEET.sheetStateToEN!=null?t(errorsFiltersSHEET.sheetStateToEN):t('Text_Filter_SheetStatus_To')}
                                  placeholder={t('PlaceHolder_Filter_SheetStatus_To')}
                                  variant="outlined"
                                  onBlur={handleBlurFilterEditSHEET}
                                  onChange={handleChangeFilterEditSHEET}
                                  select
                                  SelectProps={{
                                  native: true,
                                  }}>
                                  <option key={0} value=""/>
                                  {sheetStateToSelect.filter(item=>(i18n.language==="es"?item.namees>=filtersSHEET.sheetStateFromES:item.nameen>=filtersSHEET.sheetStateFromEN)).map(option => (
                                  <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                      {i18n.language==="es"?option.namees:option.nameen}
                                  </option>
                                  ))}
                              </TextField>
                            </div>             
                         </div>
                        <hr className="sidebar-divider d-none d-md-block" />
                        <div className="formdi-pending-action-group">
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditSHEET}>
                            {t('Button_Apply')}
                          </button> 
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersSHEET}>
                            {t('Button_Cancel_Filters')}
                          </button>
                        </div>   
                     </form>
                   </Box>
                 </Container>
               </SwipeableDrawer>
             </div>
              }  
              <SHEETPDF 
                rowEditSHEET={rowEditSHEET} 
                viewPDF={viewPDF} 
                setViewPDF={setViewPDF}
              /> 
              <Dialog open={openDeleteRowSHEET} onClose={handleCancelDeleteRowSHEET} PaperProps={{ className: "my-dialog-paper-danger" }} >
                <DialogTitle className="my-dialog-title-danger">
                  {t("Text_Delete")} {rowEditSHEET.ownsheet_id}  - {rowEditSHEET.num_sheet} - {rowEditSHEET.vehicle_model}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText-danger">
                    {t("Text_Line1")}<br />
                    {t("Text_Line2")}
                  </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCode"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDelete}
                    onChange={handleChangeDeleteRowSHEET}
                  />
                </DialogContent>
                <DialogActions className="my-dialog-actions">
                  <Button
                    onClick={handleCancelDeleteRowSHEET}
                    className="my-dialog-button-cancel-danger"
                  >
                    {t("Button_Cancel")}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCloseDeleteRowSHEET}
                    className="my-dialog-button-delete"
                  >
                    {t("Button_Delete")}
                  </Button>
                </DialogActions>
              </Dialog>  
              {/* End Content Row */}
          </>:
            <LoadingNews/>
          }
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )
}

SHEETFilter.propTypes = { 
  showModalSHEEETSettings: PropTypes.bool.isRequired,
  typeOfList: PropTypes.string.isRequired
};

export default SHEETFilter;

